enum RowAttachmentType {
  EXISTING_ROW = 'EXISTING_ROW',
  NEW_ROW = 'NEW_ROW',
}

export default RowAttachmentType;
